import React, { useState } from "react";
import SearchResults from "./SearchResults";
import {Button, Form} from "react-bootstrap"
import { XCircleFill, PlusCircleFill } from 'react-bootstrap-icons';
import { useHistory } from 'react-router-dom'
import { Banner } from '../../template/Banner'

function Search() {
  let history = useHistory();

  const defaultResults = {"persons": [], "places": [], "works": []};
  const [advancedSearchResults, setAdvancedSearchResults] = useState(defaultResults);
  const performAdvancedSearch = () => {
    console.log(inputList);
    const requestOptions = {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(inputList)
  };
  fetch('http://medpub-backend-dmpn.ext.ocp-prod-0.k8s.it.helsinki.fi/search/advanced', requestOptions)
      .then(res => res.json())
      .then(result => setAdvancedSearchResults(result));
  }

  const [showAdvancedResults, setShowAdvancedResults] = useState(false);
  const handleAdvancedSearch = e => {
    e.preventDefault();
    setAdvancedSearchResults(defaultResults);
    performAdvancedSearch();
    setShowAdvancedResults(true);
  }

  const [inputList, setInputList] = useState([{ field: "", equation: "contains", term: "" }]);
    // handle field change
    const handleFieldChange = (e, index) => {
      const list = [...inputList];
      list[index]["field"] = e.target.value;
      setInputList(list);
    };

    // handle equation change
    const handleEquationChange = (e, index) => {
      const list = [...inputList];
      list[index]["equation"] = e.target.value;
      setInputList(list);
    };

    // handle input change
    const handleInputChange = (e, index) => {
        const { name, value } = e.target;
        const list = [...inputList];
        list[index][name] = value;
        setInputList(list);
    };
    
    // handle click event of the Remove button
    const handleRemoveClick = index => {
        const list = [...inputList];
        list.splice(index, 1);
        if (index === 0) {
          list[0].op = 'and'
        }
        setInputList(list);
    };
    
    // handle click event of the Add button
    const handleAddClick = () => {
        const list = [...inputList];
        list.push({ field: "", equation: "contains", term: "", op: "and" });
        setInputList(list);
    };

    const handleRadioClick = (e, i) => {
      e.persist();
      const list = [...inputList];
      list[i].op = e.target.value;
      setInputList(list);
    }

    const clearFormAdvanced = () => {
      setInputList([{ field: "", equation: "contains", term: "" }]); 
      setShowAdvancedResults(false);
    }
  
  return (
    <div className="advanced-search">
      
      <Banner />
      <div className="page-box-tab">            
        <button className="tablinks link-simple-search inactive" onClick={() => { history.push('/search') }}><img src="search.png" alt="" />Simple search</button>
        <button className="tablinks link-adv-search active" onClick={() => { history.push('/search/advanced') }}><img src="advanced.png" alt="" />Advanced search</button>
        <button className="tablinks link-works" onClick={() => { history.push('/works') }}><img src="publishing.png" alt="" />Works</button>
        <button className="tablinks link-people" onClick={() => { history.push('/persons') }}><img src="profile.png" alt="" />People</button>
        <button className="tablinks link-places" onClick={() => { history.push('/places') }}><img src="location.png" alt="" />Places</button>
      </div>

      <div className="container">
        <div className="search-page-container">

          <div className="search-page-content">
              {inputList.map((x, i) => {
              return (
              <div>
                  <div className="advanced-search-criteria-row">
                  {inputList.length > 1 && 
                    <div className="advanced-search-and-or-selector">
                      {i !== 0 && 
                      <div>
                        <Form.Check 
                          inline
                          name={`andor-${i}`}
                          value="and"
                          type={`radio`}
                          label="and"
                          checked={inputList[i].op === "and"}
                          onChange={e => handleRadioClick(e, i)}
                        />
                        <Form.Check 
                          inline
                          name={`andor-${i}`}
                          value="or"
                          type={`radio`}
                          label="or"
                          checked={inputList[i].op === "or"}
                          onChange={e => handleRadioClick(e, i)}
                        />
                      </div>
                      }
                    </div> }
                      <select className="custom-select form-control" value={x.field} onChange={e => handleFieldChange(e, i)}>
                          <option value="">--- select field ---</option>
                          <option value="work_title">Work title</option>
                          <option value="person_name">Person name</option>
                          <option value="station">Station</option>
                          <option value="place">Place</option>
                          <option value="order">Order (abbr.)</option>
                          <option value="role">Role in publication</option>
                          <option value="year">Release date</option>
                      </select>
                      <select className="custom-select form-control" value={x.equation} onChange={e => handleEquationChange(e, i)}>
                          {x.field !== 'year' && (<option value="contains" selected>contains</option>)}
                          {x.field !== 'year' && (<option value="does_not_contain">does not contain</option>)}
                          <option value="equal">equal</option>
                          <option value="not_equal">not equal</option>
                          <option value="more_than">more than</option>
                          <option value="less_than">less than</option>
                      </select>
                      <input name="term" type="text" class="form-control" aria-describedby="term" placeholder="value" value={x.term} onChange={e => handleInputChange(e, i)}/>  
                      {inputList.length !== 1 && 
                        <div className="advanced-search-remove-criteria" style={{display: 'inline'}}>
                          <Button variant="link" onClick={() => handleRemoveClick(i)}><XCircleFill />&nbsp;remove</Button>
                        </div>
                      }
                  </div>
                </div>
              );
              })}

              <div className="advanced-search-add-criteria" style={{marginTop: 20}}>
                <Button variant="link" onClick={() => handleAddClick()}><PlusCircleFill />&nbsp;Add search criteria</Button>
              </div>

              <div className="search-page-buttons">
                  <Button type="submit" className="btn btn-secondary" onClick={handleAdvancedSearch}>Search</Button>
                  <Button type="button" className="btn btn-secondary" onClick={clearFormAdvanced}>Clear</Button>
              </div>

              {showAdvancedResults && <SearchResults data={advancedSearchResults} targetWorks={true} targetPeople={true} targetPlaces={true} type="advanced" /> }
            </div>
        </div>
      </div>
    </div>
  );
}

export default Search;